import { createResourcesSlice } from '@shared/utils/createResourcesSlice';
import { ArrivalRow } from '@modules/arrivals/models/arrivalRow';
import { DepartureRow } from '@modules/departures/models/departureRow';
import { TrafficSituation } from '@modules/traffic-situations/models/trafficSituation';
import { ExtendedMessage } from '@modules/extended-information/models/extendedMessage';

export const departureRowsSlice =
  createResourcesSlice<DepartureRow>('departureRow');
export const arrivalRowsSlice = createResourcesSlice<ArrivalRow>('arrivalRow');
export const trafficSituationsSlice =
  createResourcesSlice<TrafficSituation>('trafficSituation');
export const extendedMessagesSlice =
  createResourcesSlice<ExtendedMessage>('extendedMessage');
